var _desc, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgChatTwo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 14 14",
    id: "Chat-Two-Bubbles-Oval--Streamline-Core-Neon",
    height: 14,
    width: 14,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "\n    Chat Two Bubbles Oval Streamline Icon: https://streamlinehq.com\n  ")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "chat-two-bubbles-oval--messages-message-bubble-chat-oval-conversation"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    stroke: "#ea7f4a",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M9.25001 5c1.12719 0 2.20819 0.44777 3.00519 1.2448 0.797 0.79703 1.2448 1.87803 1.2448 3.0052 0.0027 0.8366 -0.2446 1.6549 -0.71 2.35l0.71 1.9 -2.39 -0.43c-0.5748 0.2803 -1.20539 0.4273 -1.84487 0.43 -0.63947 0.0027 -1.27131 -0.139 -1.84844 -0.4144 -0.57713 -0.2754 -1.08466 -0.6776 -1.48478 -1.1764 -0.40012 -0.4988 -0.68252 -1.0815 -0.82614 -1.7047 -0.14362 -0.62311 -0.14478 -1.27064 -0.00337 -1.89429 0.14141 -0.62365 0.42173 -1.20735 0.82007 -1.70761 0.39834 -0.50026 0.90444 -0.90417 1.48058 -1.18165C7.9792 5.14347 8.61053 4.99958 9.25001 5v0Z",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    stroke: "#215250",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M9.86002 2.51004c-0.67343 -0.85693 -1.5973 -1.48255 -2.64299 -1.789757C6.17134 0.413077 5.05588 0.439575 4.02596 0.796086 2.99604 1.1526 2.10292 1.82138 1.47093 2.70932 0.838948 3.59725 0.499561 4.66016 0.500023 5.75004c-0.003099 1.036 0.303333 2.04932 0.879997 2.91L0.500023 11l2.119997 -0.38",
    strokeWidth: 1
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChatTwo);
export default __webpack_public_path__ + "static/media/Chat-Two.565fd52d1f4be9313b058443b61c5f86.svg";
export { ForwardRef as ReactComponent };